"use client"

import ComponentBusinessAssignedArea from "./ComponentBusinessAssignedArea"
import useTranslation from "../../CustomHooks/useTranslation"
import { inputFieldContent } from "../../inputfields/InputFieldContent"

export default function MainBusinessAssignedArea() {
  const { translate } = useTranslation(inputFieldContent)


  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-primary underline pt-8 pb-2">{translate('Business Assigned Area')}</h1>
      {
        <ComponentBusinessAssignedArea />
      }
    </div>
  )
}

